import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { emailValidator } from '../../theme/utils/app-validators';
import { MailChimpService } from '../../services/MailChimpService';
import { UserManagementApiService } from '../../services/UserManagementApiService';
import { BasicResponse } from '../../responses/basicResponse';
import { Observable, map, take } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({ standalone: false,
  selector: 'app-newsletter',
  templateUrl: './newsletter.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./newsletter.component.scss']
})
export class NewsletterComponent {
  public feedbackForm: FormGroup;
  public subscribeForm: FormGroup;

  // false: browser subscribes directly at Mailchimp via JSONP (MailChimpService, deprecated in Angular 22.1)
  // true:  subscription goes through the UserManagementApi endpoint /newsletterSubscribe
  //
  // Cleanup once switched to true and verified in all environments:
  //  - delete services/MailChimpService.ts and its provider registration in app.module.ts
  //  - remove the JSONP branch in subscribe() below and this flag (call umApiService.subscribeToNewsletter directly)
  //  - remove mailchimp_subscribe_service_url, mailchimp_user_id and mailchimp_audience_id from app.config.ts
  //    and from config.development.json, config.staging.json and config.production.json
  //  - terraform_environments/parameter-store.tf: remove /shared/mailchimp_subscribe_service_url and /shared/mailchimp_user_id
  //    (keep /shared/mailchimp_audience_id - the UserManagementApi uses it)
  //  => this also removes the last use of the deprecated HttpClient.jsonp
  private readonly useServerSideSubscription = true;

  constructor(private mailChimpService:MailChimpService, private umApiService:UserManagementApiService, private snackBar: MatSnackBar) {
     this.feedbackForm = new FormGroup({ 
      email: new FormControl<string>('', Validators.compose([Validators.required, emailValidator])), 
      message: new FormControl<string>('', Validators.required)
    });
    this.subscribeForm = new FormGroup({
      email: new FormControl<string>('', Validators.compose([Validators.required, emailValidator]))
    });
  }

  get canSubscribe(){
    return this.subscribeForm.valid && this.subscribeForm.dirty;
  }

  public onSubscribeFormSubmit(values:Object):void {
    if (this.subscribeForm.valid) {
      this.subscribe(values).pipe(take(1)).subscribe(response => {
        this.processSubscriptionResult(response);});
    };
  }

  private subscribe(values:any):Observable<BasicResponse>{
    if(this.useServerSideSubscription) return this.umApiService.subscribeToNewsletter(values.email);
    // Mailchimp JSONP answers with { result: 'success' | 'error', msg: string }
    return this.mailChimpService.subscribeToList(values).pipe(map((r:any) => Object.assign(new BasicResponse(), { success: r.result=='success', message: r.msg })));
  }

  private processSubscriptionResult(response:BasicResponse){
    if(response.success){
        this.subscribeForm.markAsPristine();
        this.snackBar.open(response.message ?? '', '×', {
            verticalPosition: 'top',
            duration: 5000
          });
    }
    else{
        this.snackBar.open(response.message ?? '', '×', { panelClass: ['warn-snackbar'], verticalPosition: 'top'});
    }
  }

}
